export const QueryParamsConst = {
  ORDER: 'order',
  PAGE: 'page',
  PER_PAGE: 'take',
  QUERY: 'q',
  FILTERS: 'filters',
  // news filter
  YEAR: 'year',
  LINE: 'line',
  TYPE: 'type',
  FILTER1: 'filter1',
  // build and price filters
  SERIES: 'series',
  MODEL: 'model',
  // Download Brochure Filters
  CATEGORIES: 'categories',
  SEARCH_BROCHURE: 'searchbrochure',
  SEARCH_BROCHURE_ID: 'searchid',

  // Splash Page
  USER_MARKET_SELCTION: 'usermarketselection',
};
